<template>
	<div class="w-100" style="padding-top: 1rem">
		<label class="mb-0" style="color:#b4bebf" v-if="label!=''">
			{{label}}
		</label>
		<div
			:id="id_tag"
			class="form-Control pointer"
			:class="textClass"
			style="background-color: #f5fafd; border: 1px solid #e5ebeb; color: #219580; border-radius:10px;"
			@click="show = true"
		>
			{{ (value=='' || value==null)? label : value }}
		</div>
		<date-picker
			:min="min"
			:show="show"
			:input-format="inputFormat"
			:format='format'
			:autofocus="autofocus"
			:custom-input="'#'+id_tag"
			color="#1b60c6"
			inputClass="d-none"
			spanClass="d-none"
			v-model="value"
			@close="show=false"
			@input="inputTxt($event)"
		/>
	</div>
</template>
<script>
	export default {
		name: 'yearInput',
		data(){
			return {
				show: false,

			}
		},
		components: {
		},
		props: {
			id_tag:{
				default: "customInput",
			},
			label: {
				type: String,
				default: "label",
			},
			value: {
				type: String,
				default: "",
			},
			placeholder: {
				type: String,
				default: "",
			},
			textClass: {
				type: String,
				default: "",
			},
			inputFormat: {
				type: String,
				default: "YYYY/MM/DD",
			},
			format: {
				type: String,
				default: "jYYYY/jMM/jDD",
			},
			min: {
				type: String,
				default: "",
			},
		},
		mounted(){
			this.placeholder = (this.placeholder!='') ? this.placeholder : this.label;
			if(this.min == ''){
				this.getToday();
			}
		},
		methods:{
			//________________________________________________________________________
			getToday(THIS = this){
				if(THIS.min == ''){
					if(THIS.$localStorage.get('date') == null){
						window.$.get(window.baseurl+'date', {}, function(D){
							THIS.min = D.data;
							THIS.$localStorage.set('date', D.data);
						});
					}else{
						this.min = THIS.$localStorage.get('date');
					}
				}
			},
			//________________________________________________________________________
			inputTxt(){
				this.$emit('input', this.value);
			}
			//________________________________________________________________________
		}
	}
</script>

<style scope>
.vpd-input-group{
	display: none !important;
}
</style>
